<template>
  <!-- Modal -->
  <div class="modal fade" id="infoMinoreNonAccompagnato" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="infoMinoreNonAccompagnato" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modalInfo">
      <div class="modal-content">
        <div class="modal-header">
          <img class="aereoPopup" src="https://www.rimborsoalvolo.it/cresources/outform/images/aereoPopup.svg">
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h2>Importante</h2>
          <p style="text-align: justify">
            Inserisci i dati del genitore per inoltrare la richiesta. Successivamente ti chiederemo i dati del minore
          </p>
          <br>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">OK</button>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
<script setup lang="ts">
</script>